import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedProjectIds: [],
  queryString: ''
}
const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    projectIdToggled: (state, action) => {
      const isExist = state.selectedProjectIds.find(pid => pid == action.payload);

      if (isExist) {
        state.selectedProjectIds = state.selectedProjectIds.filter(pid => pid !== action.payload);
      } else {
        state.selectedProjectIds.push(action.payload)
      }
    },

    queryStringChanged: (state, action) => {
      state.queryString = action.payload;
    }
  }
})

export const { projectIdToggled, queryStringChanged } = tasksSlice.actions;
export default tasksSlice.reducer;